import React from 'react'
import TealToolTip from 'components/TealToolTip'
import Icon from 'components/shared/Icon'

const EncryptionUrlBadge = ({ isPrimary, count }) => !isPrimary
  ? null
  : (
    <TealToolTip arrow title={`Primary key [${count}]`}>
      <span>
        <Icon name='icon-star' className='vm mb1' />
      </span>
    </TealToolTip>
    )

export default EncryptionUrlBadge
